import { EventEmitter, Injectable, Output } from '@angular/core';
import { MetadataService } from '../metadata/metadata.services';

@Injectable({
  providedIn: 'root',
})
export class CommonProvider {
  @Output() insitutionChange = new EventEmitter();

  constructor(private metadataService: MetadataService) {}

  handleInstitutionChanges(data: any) {
    if (data && data.logo) {
      this.insitutionChange.emit(data);
    }
    this.metadataService.brandLogo.next(data.logo);
  }
}
